/* !
 * lp_common.js v1.0.0
 * Copyright, Connecty Inc.
 */
(() => {
	const siteName = 'hakutsuru';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			isGlobal: location.pathname.indexOf('/global/'),
			region: location.pathname.indexOf('/global/') === -1 ? 'jp' : location.pathname.split('/')[2],
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			brand: location.pathname.split('/')[1]
		},
		localDecision() {
			var regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				if (path.indexOf('inc_') !== -1) {
					ajaxArray.push(path);
				}
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		setAgeCheck() {
			const bekkaku_load = () => {
				// ロード完了の処理
				function loading_complite() {
					const loadingElement = document.getElementById('l-bekkaku-loading');
					if (loadingElement) {
						// fadeOut の代替 (シンプルな非表示)
						loadingElement.style.transition = 'opacity 0.5s ease-out';
						loadingElement.style.opacity = '0';
						setTimeout(() => {
							loadingElement.style.display = 'none';
						}, 500); // トランジション時間後に非表示
					}
					// scrollTop: 0 の代替
					window.scrollTo({ top: 0, behavior: 'auto' }); // 即時スクロール
				}

				// 5秒間ロードが終わらなかったら強制的に表示
				let delay_timer = setTimeout(() => {
					window.removeEventListener('load', handleLoad); // ロードイベントリスナーを削除
					loading_complite();
				}, 5000);

				// ロード完了後表示
				const handleLoad = () => {
					clearTimeout(delay_timer);
					loading_complite();
				};
				window.addEventListener('load', handleLoad, { once: true }); // 一度だけ実行
			};

			// 年齢確認済みかチェック (sessionStorage と cookie)
			const isAgeChecked = sessionStorage.getItem('ageCheck') || document.cookie.split(';').some((item) => item.trim().startsWith('ageCheck='));

			if (!isAgeChecked) {
				// 年齢確認モーダルのHTML
				const HTML = '<div class="ageCheck-overlay">' +
					'<div class="ageCheck-closeArea"></div>' +
					'<div class="ageCheck"><img src="/common/images/logo.svg" alt="白鶴 ロゴ" class="__logo">' +
					'<p class="__lead">このページはお酒に関する<br data-view="sp">情報が含まれておりますので、<br> 20歳未満の方はご覧いただけません。</p>' +
					'<p class="__main">あなたは<br data-view="sp">20歳以上ですか？</p>' +
					'<div class="pure-g"><div class="pure-u-1-2 pure-u-md-1">' +
					'<span class="__button js-ageCheck" data-target="true"><span>はい</span>' +
					'<svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow"></use></svg></span></div>' +
					'<div class="pure-u-1-2 pure-u-md-1">' +
					'<span class="__button js-ageCheck" data-target="false"><span>いいえ</span></span></div></div>' +
					'<div class="__check"><label for="ageCheckAgreement" class="__check-box">' +
					'<input type="checkbox" class="__check-input js-setCookie" name="ageCheckAgreement" id="ageCheckAgreement">' +
					'<span class="__check-text">次回から表示させない</span></label></div>' +
					'</div></div>';

				// body にモーダルを追加
				document.body.insertAdjacentHTML('beforeend', HTML);

				const overlayElement = document.querySelector('.ageCheck-overlay');

				if (overlayElement) {
					// モーダル表示のためのクラスを追加
					overlayElement.classList.add('is-active');

					// 特定ブランド以外では背景固定
					if (FUNCTIONS.va.brand !== '280th') {
						document.body.classList.add('is-fixed');
					}

					// 少し遅延させて表示アニメーションを開始
					setTimeout(() => {
						overlayElement.classList.add('is-visible');

						// 「はい」ボタンのクリックイベント
						const yesButton = overlayElement.querySelector('.js-ageCheck[data-target="true"]');
						if (yesButton) {
							yesButton.addEventListener('click', (e) => {
								e.preventDefault(); // デフォルトの動作をキャンセル
								sessionStorage.setItem('ageCheck', 'true'); // セッションストレージに保存

								// モーダルを非表示にするクラスを削除
								overlayElement.classList.remove('is-visible');
								document.body.classList.remove('is-fixed'); // 背景固定を解除

								// アニメーション後に要素を削除
								setTimeout(() => {
									overlayElement.classList.remove('is-active');
									overlayElement.remove();
								}, 400);

								// Cookie保存チェックボックスの状態を確認
								const setCookieCheckbox = overlayElement.querySelector('.js-setCookie');
								if (setCookieCheckbox && setCookieCheckbox.checked) {
									// チェックされていればCookieを保存 (有効期限約90日)
									document.cookie = 'ageCheck=true; max-age=7776000; path=/; SameSite=Lax';
								} else {
									// チェックされていなければCookieを削除
									document.cookie = 'ageCheck=; max-age=0; path=/; SameSite=Lax';
								}

								// 'bekkaku' ブランドの場合、ロード処理を実行
								if (FUNCTIONS.va.brand === 'bekkaku') {
									bekkaku_load();
								}
							});
						}

						// 「いいえ」ボタンのクリックイベント
						const noButton = overlayElement.querySelector('.js-ageCheck[data-target="false"]');
						if (noButton) {
							noButton.addEventListener('click', (e) => {
								e.preventDefault(); // デフォルトの動作をキャンセル
								// 特に何もしない（元のコードの return false に相当）
							});
						}
					}, 10); // わずかな遅延で transition を有効にする

				} else {
					console.error('Age check overlay element not found after insertion.');
				}

			} else {
				// 年齢確認済みの場合で 'bekkaku' ブランドならロード処理を実行
				if (FUNCTIONS.va.brand === 'bekkaku') {
					bekkaku_load();
				}
			}
		},
		scrollToObject(_target) {
			let hash = (_target.currentTarget) ? _target.currentTarget.href.split('#')[1] : _target.slice(1);
			if (hash === 'pagetop' || document.getElementById(hash)) {
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
		},
		waitForScrollComplete(_hash) {
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					if (document.getElementById(hash).querySelectorAll(focusableElementsSelector).length) {
						const focusableElements = document.getElementById(hash).querySelectorAll(focusableElementsSelector);
						if (focusableElements.length) {
							focusableElements[0].focus({ preventScroll: true });
						}
					}
				}
			};
			let scrollResolveTimeout;
			return new Promise((resolve) => {
				const scrollTimeout = setTimeout(() => {
					resolve(true);
				}, 100);
				const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
					clearTimeout(scrollTimeout);
					clearTimeout(scrollResolveTimeout);
					scrollResolveTimeout = setTimeout(() => {
						scrollFocus(_hash);
						removeEventListener('scroll', fn);
						resolve(true);
					}, 100);
				});
			});
		},
		easeScroll() {
			// スクロール完了後に実行する関数
			document.querySelectorAll('a[rel="scroll"], a[href="#pagetop"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						FUNCTIONS.scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await FUNCTIONS.waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		pageTop() {
			let pagetop = document.querySelector('.footer-pagetop');
			if (pagetop) {
				let options = {
					rootMargin: '0px',
					threshold: [0, 1],
				};
				const callbackTop = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							pagetop.classList.remove('is-visible');
						} else {
							pagetop.classList.add('is-visible');
						}
					});
				};
				const callbackBottom = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							pagetop.classList.add('is-bottom');
						} else {
							pagetop.classList.remove('is-bottom');
						}
					});
				};

				let observerTop = new IntersectionObserver(callbackTop, options);
				let header = (document.querySelector('.header')) ? document.querySelector('.header') : document.querySelector('header');
				observerTop.observe(header);

				let observerBottom = new IntersectionObserver(callbackBottom, options);
				observerBottom.observe(document.querySelector('.footer'));
			}
		},
		loadDelayScript() {
			var _this = this;
			_this.easeScroll();
			_this.pageTop();

			if (!(location.pathname.split('/')[1] === 'recruit')) {
				_this.setAgeCheck();
			}
		}
	}

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
